/**
 * Индикатор присутствия на аватаре.
 * - онлайн + mobile → зелёная иконка телефона
 * - онлайн + tablet → зелёная иконка планшета
 * - онлайн + pc/null → зелёный круг (точка)
 * - оффлайн → серый круг
 *
 * props:
 *  online: boolean
 *  device: "mobile" | "tablet" | "pc" | null
 *  size: px (default 14)
 *  stroke: цвет обводки (default "#fff")
 */
export default function OnlineIndicator({ online, device, size = 22, deviceSize }) {
  const green = "#10b981"; // emerald-500
  const gray = "#cbd5e1";  // slate-300
  const color = online ? green : gray;
  const dSize = deviceSize ?? size;
  const strokeW = Math.max(2, size * 0.18);
  const dStrokeW = Math.max(2, dSize * 0.18);

  if (online && device === "mobile") {
    return <PhoneShape size={dSize} stroke={color} strokeW={dStrokeW} />;
  }
  if (online && device === "tablet") {
    return <TabletShape size={dSize} stroke={color} strokeW={dStrokeW} />;
  }
  // точка для PC и оффлайна (с белой обводкой чтобы читалось на аватарке)
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r={12 - strokeW / 2} fill={color} stroke="#ffffff" strokeWidth={strokeW} />
    </svg>
  );
}

// Фигура из phone-online.svg (корневой файл проекта): белая внешняя обводка + зелёный корпус + speaker + home
function PhoneShape({ size, stroke }) {
  const w = size * (35 / 59);
  return (
    <svg width={w} height={size} viewBox="12.5 2.5 35 59" fill="none" aria-hidden="true">
      <rect x="13.5" y="3.5" width="33" height="57" rx="8.5" stroke="#FFFFFF" strokeWidth="2" />
      <rect x="16" y="6" width="28" height="52" rx="6" stroke={stroke} strokeWidth="3" />
      <line x1="26" y1="12" x2="34" y2="12" stroke={stroke} strokeWidth="3" strokeLinecap="round" />
      <circle cx="30" cy="51" r="2.5" fill={stroke} />
    </svg>
  );
}

function TabletShape({ size, stroke }) {
  // Планшет — тот же шейп с чуть другими пропорциями
  const w = size * (42 / 55);
  return (
    <svg width={w} height={size} viewBox="10.5 4.5 42 55" fill="none" aria-hidden="true">
      <rect x="11.5" y="5.5" width="40" height="53" rx="6" stroke="#FFFFFF" strokeWidth="2" />
      <rect x="14" y="8" width="35" height="48" rx="4" stroke={stroke} strokeWidth="3" />
      <circle cx="31.5" cy="51" r="2.3" fill={stroke} />
    </svg>
  );
}
